export default {
  apiKey: "AIzaSyCdKu6qPbPOshq1k9WwML6uKkyPiOAC5-0",
  authDomain: "uhlauth.firebaseapp.com",
  databaseURL: "https://uhlauth.firebaseio.com",
  projectId: "uhlauth",
  storageBucket: "uhlauth.appspot.com",
  messagingSenderId: "840038091745"
};
